import { TFunction } from "@impero-com/common/utils/i18n";

import { EntityForUserListDto } from "api/generated/model";
import { ReassignmentFailure } from "org/user/components/ReassignmentFailureAlert";
import { describeAdminAccessFailure } from "org/user/utils/describeAdminAccessFailure";

export function describeEntityFailure(
    t: TFunction,
    error: unknown,
    data: EntityForUserListDto
): ReassignmentFailure | null {
    return describeAdminAccessFailure(
        error,
        t("AccessAndAssignment_ReassignError_NoAdmin_Entities"),
        (id) =>
            data.content.find((dto) => dto.resource.entity.id.toString() === id)
                ?.resource.entity.name ?? id
    );
}
